import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { orderByValues } from "../../../data/data";
import styleConstants from "../../../styleConstants";
import MirroredBarChart from "../../chart/MirroredBarChart";

const ShareWithinPrivateSectorByGniGroupChart = props => {
  const data = props.data;

  const areas = [
    "Low-Income (LIC)",
    "Lower-Middle-Income (L-MIC)",
    "Upper-Middle-Income (U-MIC)"
  ];

  return (
    <MirroredBarChart
      ref={props.innerRef}
      height={125}
      headerOffset={52}
      categories={["LIC", "L-MIC", "U-MIC"]}
      series={[
        {
          name: "Private (Subsidized)",
          color:
            styleConstants.categoryColors.sectorColors["Private Subsidized"],
          data: orderByValues(
            data.filter(datum => datum.sector === "Private Sub"),
            areas,
            "area"
          ).map(datum => -datum.value)
        },
        {
          name: "Private (Non-Subsidized)",
          color:
            styleConstants.categoryColors.sectorColors[
              "Private Non-Subsidized"
            ],
          data: orderByValues(
            data.filter(datum => datum.sector === "Private Non-Sub"),
            areas,
            "area"
          ).map(datum => datum.value)
        }
      ]}
      legendPosition="none"
      absolute={props.absolute}
      tooltipFormatter={props.tooltipFormatter}
    />
  );
};

ShareWithinPrivateSectorByGniGroupChart.propTypes = {
  data: PropTypes.array.isRequired,
  absolute: PropTypes.bool,
  tooltipFormatter: PropTypes.func
};

export default memo(
  React.forwardRef((props, ref) => (
    <ShareWithinPrivateSectorByGniGroupChart innerRef={ref} {...props} />
  ))
);
